import React from 'react';
import { Award, ExternalLink } from 'lucide-react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
interface CertificationLink {
  title: string;
  description: string;
  url: string;
  icon: string;
}
const certifications: CertificationLink[] = [{
  title: 'Credly Badges',
  description: 'Professional certifications and digital credentials',
  url: 'https://www.credly.com/users/khurana-aditya/badges#credly',
  icon: '🏆'
}, {
  title: 'Maven Course Completion',
  description: 'Completed specialized training programs',
  url: 'https://maven.com/wrap-up/ca7ca929',
  icon: '📚'
}, {
  title: 'LinkedIn Certifications',
  description: 'Complete certification history and credentials',
  url: 'https://www.linkedin.com/in/khurana-aditya/details/certifications/',
  icon: '✓'
}];
export function Certifications() {
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-27">
      {certifications.map((cert, index) => <Card key={index} className="p-6 hover:shadow-lg transition-all duration-300 border-t-4 border-t-primary/50 group" data-id="element-28">
          <div className="flex flex-col h-full" data-id="element-29">
            <div className="flex items-center gap-3 mb-4" data-id="element-30">
              <div className="text-4xl" data-id="element-31">{cert.icon}</div>
              <Award className="w-6 h-6 text-primary" data-id="element-32" />
            </div>

            <h3 className="font-bold text-lg text-foreground mb-2" data-id="element-33">
              {cert.title}
            </h3>

            <p className="text-muted-foreground text-sm mb-4 flex-grow" data-id="element-34">
              {cert.description}
            </p>

            <Button variant="outline" className="w-full gap-2 group-hover:bg-primary group-hover:text-primary-foreground transition-colors" onClick={() => window.open(cert.url, '_blank')} data-id="element-35">
              View Credentials
              <ExternalLink className="w-4 h-4" data-id="element-36" />
            </Button>
          </div>
        </Card>)}
    </div>;
}